import { z } from 'zod';
import { dateField } from '@shared/schemas';
import { baseFloorSchema } from './IBaseFloor';
import { areaResponseSchema } from './IAreaResponse';
import { professionResponseSchema } from './IProfessionResponse';
import { activityLabelSchema } from './IActivityLabel';
import { ActivityGroupStatus } from './ActivityGroupStatus.enum';

// Schemas (source of truth) — pure validation, no transforms
export const assignedActivityForClientSchema = z.object({
	_id: z.string().optional(),
	description: z.string(),
	floor: baseFloorSchema,
	areas: z.array(areaResponseSchema),
	profession: professionResponseSchema,
	assignee: z.string().nullable().optional(),
	status: z.enum(ActivityGroupStatus),
	startDate: dateField,
	endDate: dateField,
	label: activityLabelSchema.nullable(),
	groupId: z.string().optional(),
	issues: z.array(z.any()).optional(), // IIssue is complex with generics - using any for schema
	linkedSequenceId: z.string().nullable().optional(),
});

// Types (derived from schemas)
// Note: IAssignedActivityForClient is kept as interface for backwards compatibility with IIssue[]
import { IIssue } from './IIssue';

export type IAssignedActivityForClient = Omit<z.infer<typeof assignedActivityForClientSchema>, 'issues'> & {
	issues?: IIssue[];
};
